

export default {
    name: 'index',
    data() {
        return {
            source: [],
            loading: false,
            total: undefined,//总页数
            pageSize: 20,//每页显示条目个数
            currentPage: 1,//当前页
        };
    },
    mounted() {
        this.getMessageFollowing()

    },
    methods: {
        async getMessageFollowing(pageNo = 1) {
            //获取关注消息列表
            this.loading = true
            let res = await this.$global.followingMessages({ page: pageNo })
            if (res.code == 200) {
                this.source = res.data.noticeList.data
                this.loading = false
                this.total = parseInt(res.data.noticeList.total)
                let messageInfo = []
                for (let key in res.data.get_message) {
                    messageInfo.push(res.data.get_message[key])
                }
                this.$store.commit('MESSAGEINFO', messageInfo)
            }
        },
        handleCurrentChange(val) {
            //分页
            this.getMessageFollowing(val)
        },
        async focusOn(id) {
            //关注用户
            let res = await this.$global.doFollow({ "fid": id })
            res.code == '200' ? (this.$message(res.msg), this.getMessageFollowing()) : ''
        },
        async unsubscribe(id) {
            //取消关注用户
            let res = await this.$global.unFollow({ "fid": id })
            res.code == '200' ? (this.$message(res.msg), this.getMessageFollowing()) : ''
        },
        async readInfo(item) {
            //已读后仅递减当前消息对应计数
            if (Number(item?.is_reader) === 0) {
                const messageInfo = Array.isArray(this.$store.state.messageInfo) ? [...this.$store.state.messageInfo] : []
                if (typeof messageInfo[2] !== 'undefined') {
                    messageInfo[2] = Math.max((Number(messageInfo[2]) || 0) - 1, 0)
                    this.$store.commit('MESSAGEINFO', messageInfo)
                }
                item.is_reader = 1
            }
            this.$global.updateNotice({ id: item?.id })
        }

    }

}
